import { createClientLogRelay } from '~/utils/createClientLogRelay'
import { flushClientLogRelayOnPageExit } from '~/utils/flushClientLogRelayOnPageExit'

export default defineNuxtPlugin({
  enforce: 'pre',
  name: 'client-log-relay',
  setup() {
    const relay = createClientLogRelay({
      send: async (entries, keepalive) => {
        const response = await fetch('/api/client-logs', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ entries }),
          keepalive,
          signal: AbortSignal.timeout(10_000)
        })
        if (!response.ok) throw new Error('Client log relay request failed')
      }
    })
    flushClientLogRelayOnPageExit(relay, window, document)
    return { provide: { clientLogRelay: relay } }
  }
})
